import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useRouter} from '@s-ui/react-router'

import {ROUTES} from '../../../../../config/index.js'

export const useNavigationTransactionBuyerInitPayment = () => {
  const {domain} = useContext(Context)
  const {push} = useRouter()

  const navigation = async interactionUrl => {
    const {searchParams} = new URL(interactionUrl)
    const tradeId = searchParams.get('tradeId')
    const adId = searchParams.get('adId')

    const [, paymentInitiatedResponse] = await domain
      .get('get_payment_initiated_transactions_use_case')
      .execute({tradeId})

    paymentInitiatedResponse
      ? push(
          `${ROUTES.TRANSACTION.BUYER_INIT_PAYMENT}?tradeId=${tradeId}&adId=${adId}&isPaymentInitiated=${paymentInitiatedResponse}`
        )
      : push(`${ROUTES.TRANSACTION.BUYER_SET_PASSCODE}?tradeId=${tradeId}&adId=${adId}`)
  }

  return navigation
}
